import { useStoreState } from '@ariakit/react';
import { Popover, PopoverDisclosure, usePopoverStore } from '@ariakit/react/popover';
import cn from 'classnames';
import { FilterIcon } from '#assets/ReactSvg.ts';
import { Button } from '../Button.tsx';
import styles from './FilterButton.module.css';

type Props = {
  children: (onApply: () => void) => React.ReactNode;
  className?: string;
  ref?: React.Ref<HTMLButtonElement>;
};

export function FilterButton({
  children,
  className,
  ref,
  /** {@link props} allows us to conform to https://ariakit.org/guide/composition#custom-components-must-be-open-for-extension */
  ...props
}: Props) {
  const popover = usePopoverStore({
    placement: 'bottom-end',
  });
  const isOpen = useStoreState(popover, 'open');

  return (
    <>
      <PopoverDisclosure
        ref={ref}
        store={popover}
        // Keep "active" style while popover is open
        className={cn(className, { 'menu-btn-active': isOpen })}
        render={<Button variant="icon" size="small" />}
        {...props}
      >
        <FilterIcon />
        <span className="visually-hidden select-none">Filters</span>
      </PopoverDisclosure>
      <Popover store={popover} portal={true} gutter={8} className={cn(styles.FilterButton_popover)}>
        {/* Unrender when not open, to clear the state. */}
        {isOpen ? children(popover.hide) : null}
      </Popover>
    </>
  );
}
